import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import {
    Checkbox,
    Paper,
    RadioGroup,
    Radio,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Validation from '../../../common/Validation';
import CleanableInput from '../../../components/Input/CleanableInput';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTypography from '../../../components/Typography/CustomTypography';
import Button from '../../../components/Button/CustomButton';
import Loader from '../../../components/Loader/Loader';
import styles from '../../../assets/jss/pages/settingShoppingCartStyle';
import WrapperContainer from '../../../components/Container/WrapperContainer';
import Snackbar from '../../../components/Snackbar/Snackbar';
import { APIErrors } from '../../../common/Constants';
import InputHasUnitAndCleanable from '../../../components/Input/InputHasUnitAndCleanable';

const useStyles = makeStyles(styles);

const SettingShoppingCartPage = ({
    eventInfo,
    isLoading,
    isCompletedGet,
    isCompleted,
    isSuccessful,
    errors,
    settingShoppingCartData,
    getSettingShoppingCart,
    updateSettingShoppingCart,
    getSettingShoppingCartClear,
    updateSettingShoppingCartClear,
}) => {
    const classes = useStyles();
    const intl = useIntl();
    const defaultParams = {
        has_credit_payment: false,
        has_bank_payment: false,
        bank_name: '三菱UFJ銀行',
        bank_name_en: 'MUFG Bank, LTD.',
        financial_institution_code: '0005',
        financial_institution_code_en: 'BOTKJPJT / BOTKJPJTXXX',
        branch_name: 'たまプラーザ支店',
        branch_name_en: 'Tama Plaza Branch',
        branch_code: '629',
        bank_account_number: '1179561',
        bank_account_number_en: '629-1179561',
        bank_account_name: '株式会社ジャンボ',
        bank_account_name_en: 'Jumbo Co., Ltd',
        bank_account_type: '',
        note: '',
        note_en: '',
    };
    const cookies = new Cookies();
    const { shortName } = useParams();

    const [params, setParams] = useState(defaultParams);
    const [validateResults, setValidateResults] = useState({});
    const [dialog, setDialog] = useState({ isOpen: false, type: 'success', message: '' });

    const accountType = { yes: '2', no: '1' };

    useEffect(() => {
        if (shortName) getSettingShoppingCart(shortName);
        return () => {
            cookies.remove('infoCard', { path: '/' });
            getSettingShoppingCartClear();
            updateSettingShoppingCartClear();
        };
    }, [shortName, getSettingShoppingCart]);

    useEffect(() => {
        if (isCompletedGet) {
            if (!_.isEmpty(settingShoppingCartData)) {
                const getDetail = {
                    has_credit_payment: settingShoppingCartData.has_credit_payment,
                    has_bank_payment: settingShoppingCartData.has_bank_payment,
                    bank_name: settingShoppingCartData.bank_name ? settingShoppingCartData.bank_name : params.bank_name,
                    bank_name_en: settingShoppingCartData.bank_name_en ? settingShoppingCartData.bank_name_en : params.bank_name_en,
                    financial_institution_code: settingShoppingCartData.financial_institution_code ? settingShoppingCartData.financial_institution_code : params.financial_institution_code,
                    financial_institution_code_en: settingShoppingCartData.financial_institution_code_en ? settingShoppingCartData.financial_institution_code_en : params.financial_institution_code_en,
                    branch_name: settingShoppingCartData.branch_name ? settingShoppingCartData.branch_name : params.branch_name,
                    branch_name_en: settingShoppingCartData.branch_name_en ? settingShoppingCartData.branch_name_en : params.branch_name_en,
                    branch_code: settingShoppingCartData.branch_code ? settingShoppingCartData.branch_code : params.branch_code,
                    bank_account_number: settingShoppingCartData.bank_account_number ? settingShoppingCartData.bank_account_number : params.bank_account_number,
                    bank_account_number_en: settingShoppingCartData.bank_account_number_en ? settingShoppingCartData.bank_account_number_en : params.bank_account_number_en,
                    bank_account_name: settingShoppingCartData.bank_account_name ? settingShoppingCartData.bank_account_name : params.bank_account_name,
                    bank_account_name_en: settingShoppingCartData.bank_account_name_en ? settingShoppingCartData.bank_account_name_en : params.bank_account_name_en,
                    bank_account_type: settingShoppingCartData.bank_account_type ? String(settingShoppingCartData.bank_account_type) : params.bank_account_type,
                    note: settingShoppingCartData.note,
                    note_en: settingShoppingCartData.note_en,
                };
                const detail = {
                    has_credit_payment: settingShoppingCartData.has_credit_payment,
                    has_bank_payment: settingShoppingCartData.has_bank_payment,
                    bank_name: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.bank_name : '',
                    bank_name_en: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.bank_name_en : '',
                    financial_institution_code: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.financial_institution_code : '',
                    financial_institution_code_en: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.financial_institution_code_en : '',
                    branch_name: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.branch_name : '',
                    branch_name_en: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.branch_name_en : '',
                    branch_code: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.branch_code : '',
                    bank_account_number: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.bank_account_number : '',
                    bank_account_number_en: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.bank_account_number_en : '',
                    bank_account_name: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.bank_account_name : '',
                    bank_account_name_en: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.bank_account_name_en : '',
                    bank_account_type: settingShoppingCartData.has_bank_payment ? String(settingShoppingCartData.bank_account_type) : '',
                    note: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.note : '',
                    note_en: settingShoppingCartData.has_bank_payment ? settingShoppingCartData.note_en : '',
                };
                setParams(detail);
                cookies.set('infoCard', getDetail, { path: '/' });
            } else {
                cookies.set('infoCard', params, { path: '/' });
            }
        }
    }, [settingShoppingCartData, isCompletedGet]);

    useEffect(() => {
        if (isCompleted && errors.code === APIErrors.badRequest) {
            setDialog({
                isOpen: true,
                type: 'error',
                message: errors.message || intl.formatMessage({ id: 'apiErrors.default' }),
            });
            updateSettingShoppingCartClear();
        }
        if (isCompleted && isSuccessful) {
            setDialog({
                isOpen: true,
                type: 'success',
                message: intl.formatMessage({ id: 'apiSuccess.default' }),
            });
        }
    }, [isCompleted, isSuccessful, errors, updateSettingShoppingCartClear, intl]);

    const handleSetParams = (field, value) => {
        setParams((prevParams) => ({ ...prevParams, [field]: value }));
    };

    const validate = () => {
        const {
            bank_name,
            financial_institution_code,
            branch_name,
            branch_code,
            bank_account_number,
            bank_account_name,
            has_credit_payment,
            has_bank_payment,
            note,
        } = params;

        const validateRules = {
            checkBox: [
                () => Validation.isAnyCheckboxSelected([has_credit_payment, has_bank_payment]),
            ],
            note: [
                () => Validation.validateMaxLength(note, 1000),
            ],
        };

        if (params.has_bank_payment) {
            validateRules.bank_name = [
                () => Validation.isNotEmpty(bank_name),
                () => Validation.validateMaxLength(bank_name, 255),
            ];
            validateRules.financial_institution_code = [
                () => Validation.isNotEmpty(financial_institution_code),
                () => Validation.isNumber(+financial_institution_code),
            ];
            validateRules.branch_name = [
                () => Validation.isNotEmpty(branch_name),
                () => Validation.validateMaxLength(branch_name, 255),
            ];
            validateRules.branch_code = [
                () => Validation.isNotEmpty(branch_code),
                () => Validation.isNumber(+branch_code),
            ];
            validateRules.bank_account_number = [
                () => Validation.isNotEmpty(bank_account_number),
                () => Validation.isNumber(+bank_account_number),
            ];
            validateRules.bank_account_name = [
                () => Validation.isNotEmpty(bank_account_name),
                () => Validation.validateMaxLength(bank_account_name, 255),
            ];
        }

        if (!_.isEmpty(eventInfo.languages)) {
            validateRules.bank_name_en = [
                () => Validation.isNotEmpty(params.bank_name_en),
                () => Validation.validateMaxLength(params.bank_name_en, 255),
                () => Validation.validateLatin(params.bank_name_en),
            ];
            validateRules.financial_institution_code_en = [
                () => Validation.isNotEmpty(params.financial_institution_code_en),
                () => Validation.validateLatin(params.financial_institution_code_en),
                () => Validation.validateMaxLength(params.financial_institution_code_en, 50),
            ];
            validateRules.branch_name_en = [
                () => Validation.isNotEmpty(params.branch_name_en),
                () => Validation.validateMaxLength(params.branch_name_en, 255),
                () => Validation.validateLatin(params.branch_name_en),
            ];
            validateRules.bank_account_number_en = [
                () => Validation.isNotEmpty(params.bank_account_number_en),
                () => Validation.validateLatin(params.bank_account_number_en),
            ];
            validateRules.bank_account_name_en = [
                () => Validation.isNotEmpty(params.bank_account_name_en),
                () => Validation.validateMaxLength(params.bank_account_name_en, 255),
                () => Validation.validateLatin(params.bank_account_name_en),
            ];
            validateRules.note_en = [
                () => params.note_en && Validation.validateLatin(params.note_en),
            ];
        }

        const validateResult = Validation.validateAllRules(validateRules);
        if (Object.keys(validateResult).length > 0) {
            setValidateResults(validateResult);
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSubmit = () => {
        if (validate() && eventInfo.has_shopping_cart) {
            let submitData = {
                has_credit_payment: params.has_credit_payment ? '1' : '0',
                has_bank_payment: params.has_bank_payment ? '1' : '0',
            };
            if (params.has_bank_payment) {
                submitData = {
                    ...submitData,
                    bank_name: params.bank_name,
                    financial_institution_code: params.financial_institution_code,
                    branch_name: params.branch_name,
                    branch_code: params.branch_code,
                    bank_account_number: params.bank_account_number,
                    bank_account_name: params.bank_account_name,
                    bank_account_type: params.bank_account_type,
                    note: params.note ? params.note : '',
                };
            }
            if (!_.isEmpty(eventInfo.languages)) {
                submitData = {
                    ...submitData,
                    bank_name_en: params.bank_name_en,
                    financial_institution_code_en: params.financial_institution_code_en,
                    branch_name_en: params.branch_name_en,
                    bank_account_number_en: params.bank_account_number_en,
                    bank_account_name_en: params.bank_account_name_en,
                    note_en: params.note_en ? params.note_en : '',
                };
            }
            updateSettingShoppingCart({ eventName: shortName, data: submitData });
        }
    };

    const handleUseBankPayment = (check) => {
        handleSetParams('has_bank_payment', check.target.checked);
        if (!check.target.checked) {
            cookies.set('infoCard', params, { path: '/' });
            setValidateResults({});
            setParams({
                ...defaultParams,
                has_credit_payment: params.has_credit_payment,
            });
        } else {
            setParams({
                ...params,
                has_bank_payment: true,
                bank_name: cookies.get('infoCard').bank_name,
                bank_name_en: cookies.get('infoCard').bank_name_en,
                financial_institution_code: cookies.get('infoCard').financial_institution_code,
                financial_institution_code_en: cookies.get('infoCard').financial_institution_code_en,
                branch_name: cookies.get('infoCard').branch_name,
                branch_name_en: cookies.get('infoCard').branch_name_en,
                branch_code: cookies.get('infoCard').branch_code,
                bank_account_number: cookies.get('infoCard').bank_account_number,
                bank_account_number_en: cookies.get('infoCard').bank_account_number_en,
                bank_account_name: cookies.get('infoCard').bank_account_name,
                bank_account_name_en: cookies.get('infoCard').bank_account_name_en,
                bank_account_type: cookies.get('infoCard').bank_account_type ? cookies.get('infoCard').bank_account_type : '2',
                note: cookies.get('infoCard').note,
                note_en: cookies.get('infoCard').note_en,
            });
        }
    };

    const handleCloseErrorDialog = (e, reason) => {
        if (reason === 'clickaway') return;
        setDialog({ ...dialog, isOpen: false });
    };

    return (
        <>
            <GridContainer style={{ marginTop: '20px' }}>
                <WrapperContainer>
                    <GridItem xs={12} md={12} className={classes.item}>
                        <div className={classes.leftTitle} style={{ paddingRight: '0' }}>
                            <CustomTypography bold required>
                                ショッピングカートの支払い方法
                            </CustomTypography>
                        </div>
                        <div className={classes.rightInput} style={{ marginBottom: '25px' }}>
                            <FormControlLabel
                                className={classes.checkBox}
                                control={(
                                    <Checkbox
                                        disabled={!eventInfo.has_shopping_cart}
                                        color="primary"
                                        checked={params.has_credit_payment}
                                        onChange={(check) => handleSetParams('has_credit_payment', check.target.checked)}
                                    />
                                )}
                                label={intl.formatMessage({ id: 'adminSettingShoppingCart.credit' })}
                            />
                            <FormControlLabel
                                className={classes.checkBox}
                                control={(
                                    <Checkbox
                                        disabled={!eventInfo.has_shopping_cart}
                                        color="primary"
                                        checked={params.has_bank_payment}
                                        onChange={(check) => handleUseBankPayment(check)}
                                    />
                                )}
                                label={intl.formatMessage({ id: 'adminSettingShoppingCart.card' })}
                            />
                            {
                                validateResults.checkBox && validateResults.checkBox.result !== 'success' && (
                                    <CustomTypography color="danger" style={{ fontSize: '0.75rem', marginLeft: '15px' }}>
                                        {validateResults.checkBox
                                            ? 'お支払い方法をお選びください。' : ''}
                                    </CustomTypography>
                                )
                            }
                        </div>
                    </GridItem>
                    <GridItem xs={12} md={12} className={classes.item} style={{ marginBottom: '30px' }}>
                        <div className={classes.leftTitle} style={{ paddingRight: '0' }}>
                            <CustomTypography bold>
                                支払い先 (銀行口座)
                            </CustomTypography>
                        </div>
                    </GridItem>
                    <GridItem>
                        <Paper elevation={3} classes={{ root: params.has_bank_payment ? classes.room : classes.disabled }}>
                            <GridItem xs={12} md={12} className={classes.item}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography required bold>
                                        銀行名
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                    <CleanableInput
                                        className={classes.right}
                                        defaultValue={params.has_bank_payment ? params.bank_name : ''}
                                        isMultiline
                                        onChange={(value) => handleSetParams('bank_name', value)}
                                        error={!!validateResults.bank_name}
                                        helperText={validateResults.bank_name
                                            ? intl.formatMessage({ id: validateResults.bank_name.message }, { maxLength: 255 }) : ''}
                                    />
                                </div>
                            </GridItem>
                            {!_.isEmpty(eventInfo.languages) && (
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography required bold>
                                            Beneficiary Bank
                                        </CustomTypography>
                                    </div>
                                    <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={params.has_bank_payment ? params.bank_name_en : ''}
                                            isMultiline
                                            onChange={(value) => handleSetParams('bank_name_en', value)}
                                            error={!!validateResults.bank_name_en}
                                            helperText={validateResults.bank_name_en
                                                ? intl.formatMessage({ id: validateResults.bank_name_en.message }, { maxLength: 255 }) : ''}
                                        />
                                    </div>
                                </GridItem>
                            )}

                            <GridItem xs={12} md={12} className={classes.item}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography required bold>
                                        金融機関コード
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                    <InputHasUnitAndCleanable
                                        className={classes.right}
                                        defaultValue={params.has_bank_payment ? params.financial_institution_code : ''}
                                        maxLength={50}
                                        onChange={(value) => handleSetParams('financial_institution_code', value)}
                                        error={!!validateResults.financial_institution_code}
                                        helperText={validateResults.financial_institution_code
                                            ? intl.formatMessage({ id: validateResults.financial_institution_code.message }) : ''}
                                    />
                                </div>
                            </GridItem>
                            {!_.isEmpty(eventInfo.languages) && (
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography required bold>
                                            SWIFT code / BIC code
                                        </CustomTypography>
                                    </div>
                                    <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={params.has_bank_payment ? params.financial_institution_code_en : ''}
                                            isMultiline
                                            onChange={(value) => handleSetParams('financial_institution_code_en', value)}
                                            error={!!validateResults.financial_institution_code_en}
                                            helperText={validateResults.financial_institution_code_en
                                                ? intl.formatMessage({ id: validateResults.financial_institution_code_en.message }, { maxLength: 50 }) : ''}
                                        />
                                    </div>
                                </GridItem>
                            )}
                            <GridItem xs={12} md={12} className={classes.item}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography required bold>
                                        支店名
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                    <CleanableInput
                                        className={classes.right}
                                        defaultValue={params.has_bank_payment ? params.branch_name : ''}
                                        isMultiline
                                        onChange={(value) => handleSetParams('branch_name', value)}
                                        error={!!validateResults.branch_name}
                                        helperText={validateResults.branch_name
                                            ? intl.formatMessage({ id: validateResults.branch_name.message }, { maxLength: 255 }) : ''}
                                    />
                                </div>
                            </GridItem>
                            {!_.isEmpty(eventInfo.languages) && (
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography required bold>
                                            Branch Name
                                        </CustomTypography>
                                    </div>
                                    <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={params.has_bank_payment ? params.branch_name_en : ''}
                                            isMultiline
                                            onChange={(value) => handleSetParams('branch_name_en', value)}
                                            error={!!validateResults.branch_name_en}
                                            helperText={validateResults.branch_name_en
                                                ? intl.formatMessage({ id: validateResults.branch_name_en.message }, { maxLength: 255 }) : ''}
                                        />
                                    </div>
                                </GridItem>
                            )}
                            <GridItem xs={12} md={12} className={classes.item}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography required bold>
                                        支店コード
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                    <InputHasUnitAndCleanable
                                        className={classes.right}
                                        defaultValue={params.has_bank_payment ? params.branch_code : ''}
                                        maxLength={50}
                                        onChange={(value) => handleSetParams('branch_code', value)}
                                        error={!!validateResults.branch_code}
                                        helperText={validateResults.branch_code
                                            ? intl.formatMessage({ id: validateResults.branch_code.message }) : ''}
                                    />
                                </div>
                            </GridItem>
                            <GridItem xs={12} md={12} className={classes.item}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography required bold>
                                        口座番号
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                    <InputHasUnitAndCleanable
                                        className={classes.right}
                                        defaultValue={params.has_bank_payment ? params.bank_account_number : ''}
                                        maxLength={50}
                                        onChange={(value) => handleSetParams('bank_account_number', value)}
                                        error={!!validateResults.bank_account_number}
                                        helperText={validateResults.bank_account_number
                                            ? intl.formatMessage({ id: validateResults.bank_account_number.message }) : ''}
                                    />
                                </div>
                            </GridItem>
                            {!_.isEmpty(eventInfo.languages) && (
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography required bold>
                                            Beneficiary Account Number
                                        </CustomTypography>
                                    </div>
                                    <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={params.has_bank_payment ? params.bank_account_number_en : ''}
                                            isMultiline
                                            onChange={(value) => handleSetParams('bank_account_number_en', value)}
                                            error={!!validateResults.bank_account_number_en}
                                            helperText={validateResults.bank_account_number_en
                                                ? intl.formatMessage({ id: validateResults.bank_account_number_en.message }) : ''}
                                        />
                                    </div>
                                </GridItem>
                            )}
                            <GridItem xs={12} md={12} className={classes.item}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography required bold>
                                        口座名義
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                    <CleanableInput
                                        className={classes.right}
                                        defaultValue={params.has_bank_payment ? params.bank_account_name : ''}
                                        isMultiline
                                        onChange={(value) => handleSetParams('bank_account_name', value)}
                                        error={!!validateResults.bank_account_name}
                                        helperText={validateResults.bank_account_name
                                            ? intl.formatMessage({ id: validateResults.bank_account_name.message }, { maxLength: 255 }) : ''}
                                    />
                                </div>
                            </GridItem>
                            {!_.isEmpty(eventInfo.languages) && (
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography required bold>
                                            Beneficiary Name
                                        </CustomTypography>
                                    </div>
                                    <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={params.has_bank_payment ? params.bank_account_name_en : ''}
                                            isMultiline
                                            onChange={(value) => handleSetParams('bank_account_name_en', value)}
                                            error={!!validateResults.bank_account_name_en}
                                            helperText={validateResults.bank_account_name_en
                                                ? intl.formatMessage({ id: validateResults.bank_account_name_en.message }, { maxLength: 255 }) : ''}
                                        />
                                    </div>
                                </GridItem>
                            )}
                            <GridItem xs={12} md={12} className={classes.itemCart}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography required bold>
                                        口座種別
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable} style={{ marginBottom: '27px' }}>
                                    <RadioGroup
                                        aria-label="bank_account_type"
                                        name="bank_account_type"
                                        value={params.bank_account_type}
                                        onChange={(e) => setParams({
                                            ...params,
                                            bank_account_type: e.target.value,
                                        })}
                                        row
                                    >
                                        <FormControlLabel
                                            value={accountType.yes}
                                            control={<Radio color="primary" checked={params.bank_account_type === '2'} />}
                                            label="普通"
                                            className={classes.radioButton}
                                        />
                                        <FormControlLabel
                                            value={accountType.no}
                                            control={<Radio color="primary" checked={params.bank_account_type === '1'} />}
                                            label="当座"
                                            className={classes.radioButton}
                                        />
                                    </RadioGroup>
                                </div>
                            </GridItem>
                            <GridItem xs={12} md={12} className={classes.item}>
                                <div className={classes.leftTitle}>
                                    <CustomTypography bold>
                                        備考
                                    </CustomTypography>
                                </div>
                                <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                    <CleanableInput
                                        className={classes.right}
                                        defaultValue={params.note}
                                        isMultiline
                                        onChange={(value) => handleSetParams('note', value)}
                                        error={!!validateResults.note}
                                        helperText={validateResults.note
                                            ? intl.formatMessage({ id: validateResults.note.message }, { maxLength: 1000 }) : ''}
                                    />
                                </div>
                            </GridItem>
                            {!_.isEmpty(eventInfo.languages) && (
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography bold>
                                            Remark
                                        </CustomTypography>
                                    </div>
                                    <div className={params.has_bank_payment ? classes.rightInput : classes.rightInputDisable}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={params.note_en}
                                            isMultiline
                                            onChange={(value) => handleSetParams('note_en', value)}
                                            error={!!validateResults.note_en}
                                            helperText={validateResults.note_en
                                                ? intl.formatMessage({ id: validateResults.note_en.message }) : ''}
                                        />
                                    </div>
                                </GridItem>
                            )}
                        </Paper>
                        <GridItem xs={12} md={12} className={classes.buttonSubmit}>
                            <Button
                                color="info"
                                round
                                gradient
                                size="md"
                                onClick={handleSubmit}
                                style={{ width: '200px' }}
                            >
                                <b>保存する</b>
                            </Button>
                        </GridItem>
                    </GridItem>
                    <Snackbar
                        open={dialog.isOpen}
                        onClose={handleCloseErrorDialog}
                        message={dialog.message}
                        severity={dialog.type}
                    />
                </WrapperContainer>
            </GridContainer>
            <Loader isLoading={isLoading} />
        </>
    );
};

SettingShoppingCartPage.defaultProps = {
    errors: {},
    settingShoppingCartData: {},
    eventInfo: {},
    getSettingShoppingCart: undefined,
    updateSettingShoppingCart: undefined,
    getSettingShoppingCartClear: undefined,
    updateSettingShoppingCartClear: undefined,
    isSuccessful: undefined,
};

SettingShoppingCartPage.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    eventInfo: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool,
        PropTypes.string,
        PropTypes.number,
    ])),
    isCompletedGet: PropTypes.bool.isRequired,
    isCompleted: PropTypes.bool.isRequired,
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    settingShoppingCartData: PropTypes.oneOfType([() => null, PropTypes.object]),
    getSettingShoppingCart: PropTypes.func,
    updateSettingShoppingCart: PropTypes.func,
    getSettingShoppingCartClear: PropTypes.func,
    updateSettingShoppingCartClear: PropTypes.func,
    isSuccessful: PropTypes.bool,
};

export default SettingShoppingCartPage;
